export const LOGIN_API = "/users/auth/login/";

export const LOGOUT_API = "/users/auth/logout/";

export const RESET_PASSWORD_EMAIL_API = "/users/password-reset/";
export const RESET_PASSWORD_CONFIRM_API = "/users/password-reset/confirm/";

export const GET_USER_SETTINGS_API = "/users/user-settings/";
export const UPDATE_USER_SETTINGS_API = "/users/user-settings/";

export const UPDATE_USER_PASSWORD_API = "/users/change-password/";

export const GET_CONNECTED_USER_API = "/users/me/";

export const ADD_PUSH_NOTIFICATION_TOKEN_API = "/users/push-notification-token/";


// WEBPACK FOOTER //
// ./src/apis/authentication.js